export default __webpack_public_path__ + "static/media/FlyingFrog7.3cb6f81a.png";